<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // 监听整个应用中的点击事件
    document.addEventListener('click', this.handleLinkClick);
  },
  beforeDestroy() {
    // 组件销毁前移除监听器，避免内存泄漏
    document.removeEventListener('click', this.handleLinkClick);
  },
  methods: {
    handleLinkClick(e) {
      // 查找被点击元素最近的父级<a>标签
      let target = e.target;
      while (target && target.tagName !== 'A') {
        target = target.parentNode;
      }

      // 如果找到了<a>标签且其href属性为'#'
      if (target && target.getAttribute('href') === '#'&&!target.classList.contains('back-to-top')) {
        e.preventDefault(); // 阻止默认行为
        alert('敬请期待！'); // 显示提示信息
      }
    }
  }
}
</script>

<style>
#app,html,body {
  height: 100%;
}
#app {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}
</style>
